import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

export function SortableDoctorItem({ doctor }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: doctor.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center gap-3 p-3 border border-light-border dark:border-border rounded-xl hover:border-silver/40 transition-colors bg-white dark:bg-charcoal"
    >
      <div
        {...attributes}
        {...listeners}
        className="cursor-grab active:cursor-grabbing text-slate-400 dark:text-silver/60 hover:text-slate-600 dark:hover:text-silver transition-colors"
      >
        <GripVertical className="w-5 h-5" />
      </div>

      <div className="flex-1 flex items-center gap-3">
        {doctor.photoUrl ? (
          <img
            src={doctor.photoUrl}
            alt={doctor.name}
            className="w-10 h-10 rounded-full object-cover"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-gradient-silver flex items-center justify-center">
            <span className="text-obsidian font-mono text-sm font-bold">
              {doctor.firstName[0]}{doctor.lastName[0]}
            </span>
          </div>
        )}
        <div className="flex-1">
          <p className="font-mono text-sm font-medium text-light-text dark:text-pure-white">{doctor.name}</p>
          {doctor.specialties && doctor.specialties.length > 0 && (
            <p className="text-xs text-light-text-secondary dark:text-silver/60">
              {doctor.specialties.join(', ')}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
